import { useEffect } from 'react';

import { useLocation } from '@lumapps/router';

const HEADER_HEIGHT = 116;

/**
 * Hook to scroll to an element based on the hash in the URL.
 * The scroll will occured when the page is loaded if the hash was there before loading the page.
 * It will also occur every time a react-router Link is clicked with a hash in the URL.
 */
export function useScrollToHash(readyToScroll: boolean) {
    const location = useLocation();

    useEffect(() => {
        if (readyToScroll && location.hash && location.hash !== '#comments') {
            // Extract element id from location hash (removing #).
            const elementId = location.hash?.replace(/^#/, '');

            setTimeout(() => {
                const element = document.getElementById(elementId);
                if (element) {
                    const y = element.getBoundingClientRect().top + window.pageYOffset - HEADER_HEIGHT;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }, 0);
        }
    }, [readyToScroll, location.hash]);

    /**
     * Even if we only use the `hash` parameter from location, we have to use `location.key`
     *   as dependency for the useEffect. This allow the hook to be triggered each time the user
     *   clicks on the scroll action button because a click after the first one won't change the
     *   `location.hash` part but will cause `location.key` to be changed and thus trigger this
     *   useEffect.
     */
    useEffect(() => {
        if (readyToScroll && location.hash && location.hash === '#comments') {
            setTimeout(() => {
                const element = document.querySelector('.widget-comments');
                if (element) {
                    const y = element.getBoundingClientRect().top + window.pageYOffset - HEADER_HEIGHT;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }, 0);
        }
    }, [readyToScroll, location.hash, location.key]);
}
